/* Deska po Desce: wspólne skrypty landingu (zgody przed zakupem, podgląd projektów, powiększanie zdjęć).
   Dołączany przez kilka sekcji, więc każda część rejestruje się tylko raz.
   Strona niemiecka (Brett für Brett) ma data-dpd-lang="de" przy przycisku zakupu i dostaje niemieckie teksty. */
(function () {
  if (window.dpdLandingInit) return;
  window.dpdLandingInit = true;

  var TXT = {
    pl: {
      groups: [
        { attr: 'data-dpd-consent', key: 'Zgoda na natychmiastowe dostarczenie', text: 'Tak, przyjmuję do wiadomości utratę prawa odstąpienia od umowy' },
        { attr: 'data-dpd-terms', key: 'Akceptacja regulaminu', text: 'Tak, akceptuję Regulamin sklepu' }
      ],
      both: 'Zaznacz oba pola powyżej, aby przejść do płatności.',
      notify: { key: 'Powiadomienia o nowych poradnikach', text: 'Tak, proszę o e-mail, gdy pojawi się nowy poradnik' },
      locale: 'pl-PL', tz: 'Europe/Warsaw',
      box: { label: 'Podgląd', close: 'Zamknij', prev: 'Poprzedni', next: 'Następny' }
    },
    de: {
      groups: [
        { attr: 'data-dpd-consent', key: 'Zustimmung zur sofortigen Bereitstellung', text: 'Ja, mir ist bekannt, dass ich mein Widerrufsrecht verliere' },
        { attr: 'data-dpd-terms', key: 'AGB akzeptiert', text: 'Ja, ich akzeptiere die AGB' }
      ],
      both: 'Bitte setze beide Häkchen oben, um zur Kasse zu gehen.',
      notify: { key: 'Benachrichtigung über neue Pläne', text: 'Ja, bitte per E-Mail informieren, wenn neue Pläne erscheinen' },
      locale: 'de-DE', tz: 'Europe/Berlin',
      box: { label: 'Vorschau', close: 'Schließen', prev: 'Zurück', next: 'Weiter' }
    }
  };
  function lang() { return document.querySelector('[data-dpd-lang="de"]') ? TXT.de : TXT.pl; }

  /* Zgody: natychmiastowe dostarczenie i regulamin. Po kliknięciu „Kupuję” bez zgód podświetlamy
     od razu wszystkie brakujące pola i pokazujemy jeden komunikat pod ostatnim z nich. */
  var GROUPS = TXT.pl.groups;
  function boxes(attr) { return document.querySelectorAll('[' + attr + '] input[type="checkbox"]'); }
  function b64url(str) {
    var bytes = new TextEncoder().encode(str), bin = '';
    for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_');
  }
  function clearAlert(box) {
    box.classList.remove('is-alert', 'is-quiet');
    var msg = box.querySelector('.dpd-consent__msg');
    if (msg && msg.dataset.dpdText) { msg.textContent = msg.dataset.dpdText; delete msg.dataset.dpdText; }
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-dpd-notify]')) {
      var onN = e.target.checked;
      document.querySelectorAll('[data-dpd-notify] input').forEach(function (b) { b.checked = onN; });
    }
    GROUPS.forEach(function (g) {
      if (!e.target.closest('[' + g.attr + ']')) return;
      var on = e.target.checked;
      boxes(g.attr).forEach(function (b) { b.checked = on; });
      document.querySelectorAll('[' + g.attr + '].is-alert').forEach(clearAlert);
    });
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dpd-buy]');
    if (!btn || !boxes(GROUPS[0].attr).length) return;
    e.preventDefault();
    var L = lang();
    var when = new Date().toLocaleString(L.locale, { timeZone: L.tz });
    var props = {}, missing = [];
    var scope = btn.closest('[data-dpd-buy-scope]');
    L.groups.forEach(function (g) {
      var all = boxes(g.attr);
      if (!all.length) return;
      if (all[0].checked) { props[g.key] = g.text + ' (' + when + ')'; return; }
      missing.push((scope && scope.querySelector('[' + g.attr + ']')) || document.querySelector('[' + g.attr + '-main]') || document.querySelector('[' + g.attr + ']'));
    });
    if (missing.length) {
      document.querySelectorAll('.dpd-consent.is-alert').forEach(clearAlert);
      missing.forEach(function (box, i) {
        void box.offsetWidth;
        box.classList.add('is-alert');
        if (missing.length > 1 && i < missing.length - 1) box.classList.add('is-quiet');
      });
      if (missing.length > 1) {
        var msg = missing[missing.length - 1].querySelector('.dpd-consent__msg');
        if (msg) { msg.dataset.dpdText = msg.textContent; msg.textContent = L.both; }
      }
      missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      missing[0].querySelector('input').focus({ preventScroll: true });
      return;
    }
    /* Marka może podać własny tekst zgody na powiadomienia atrybutami na <body>
       (Myśl po Myśli: data-dpd-notify-key i data-dpd-notify-text w layout/theme.liquid). */
    var nb = document.querySelector('[data-dpd-notify] input');
    var nKey = document.body.getAttribute('data-dpd-notify-key') || L.notify.key;
    var nText = document.body.getAttribute('data-dpd-notify-text') || L.notify.text;
    if (nb && nb.checked) props[nKey] = nText + ' (' + when + ')';
    var url = btn.getAttribute('href');
    window.location.href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'properties=' + encodeURIComponent(b64url(JSON.stringify(props)));
  });

  /* Podgląd: nazwy projektów w spisie i strony z galerii otwierają się w powiększeniu.
     Elementy z [data-dpd-zoom] w tym samym [data-dpd-zoom-group] można przewijać strzałkami i gestem. */
  var box, img, cap, list = [], idx = 0, lastFocus = null, touchX = null;
  function build() {
    var B = lang().box;
    box = document.createElement('div');
    box.className = 'dpd-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', B.label);
    box.hidden = true;
    box.innerHTML = '<button type="button" class="dpd-lightbox__close" aria-label="' + B.close + '">&times;</button>' +
      '<button type="button" class="dpd-lightbox__nav dpd-lightbox__prev" aria-label="' + B.prev + '">&#8592;</button>' +
      '<figure class="dpd-lightbox__fig"><img alt=""><figcaption></figcaption></figure>' +
      '<button type="button" class="dpd-lightbox__nav dpd-lightbox__next" aria-label="' + B.next + '">&#8594;</button>';
    document.body.appendChild(box);
    img = box.querySelector('img');
    cap = box.querySelector('figcaption');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.dpd-lightbox__prev')) return go(-1);
      if (e.target.closest('.dpd-lightbox__next')) return go(1);
      if (e.target.closest('.dpd-lightbox__close') || !e.target.closest('.dpd-lightbox__fig')) close();
    });
    box.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX; touchX = null;
      if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
    });
  }
  function show() {
    var el = list[idx];
    img.src = el.getAttribute('data-dpd-zoom') || el.getAttribute('href');
    img.alt = el.getAttribute('data-dpd-caption') || '';
    cap.textContent = el.getAttribute('data-dpd-caption') || '';
    var many = list.length > 1;
    box.querySelector('.dpd-lightbox__prev').hidden = !many;
    box.querySelector('.dpd-lightbox__next').hidden = !many;
  }
  function go(d) { if (list.length < 2) return; idx = (idx + d + list.length) % list.length; show(); }
  function open(el) {
    if (!box) build();
    var group = el.closest('[data-dpd-zoom-group]');
    list = group ? Array.prototype.slice.call(group.querySelectorAll('[data-dpd-zoom]')) : [el];
    idx = Math.max(0, list.indexOf(el));
    lastFocus = el;
    show();
    box.hidden = false;
    document.documentElement.classList.add('dpd-noscroll');
    box.querySelector('.dpd-lightbox__close').focus();
  }
  function close() {
    box.hidden = true;
    img.removeAttribute('src');
    document.documentElement.classList.remove('dpd-noscroll');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-dpd-zoom]');
    if (!el || (box && box.contains(el))) return;
    e.preventDefault();
    open(el);
  });
  document.addEventListener('keydown', function (e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'ArrowLeft') go(-1);
  });
})();
